// src/components/molecules/ModeToggle.jsx
import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import StorageRoundedIcon from "@mui/icons-material/StorageRounded";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";

/**
 * Toggle between Standard (DB templates) and AI Enhanced report generation modes.
 */
export default function ModeToggle({ mode, onChange, disabled }) {
  return (
    <Box>
      <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.5, fontWeight: 600 }}>
        GENERATION MODE
      </Typography>
      <ToggleButtonGroup
        value={mode}
        exclusive
        onChange={(_, val) => { if (val) onChange(val); }}
        size="small"
        disabled={disabled}
        fullWidth
      >
        <ToggleButton value="standard" sx={{ gap: 0.5, fontWeight: 600, fontSize: 12 }}>
          <StorageRoundedIcon fontSize="small" />
          Standard (DB)
        </ToggleButton>
        <ToggleButton value="ai" sx={{ gap: 0.5, fontWeight: 600, fontSize: 12 }}>
          <AutoAwesomeRoundedIcon fontSize="small" />
          AI Enhanced
        </ToggleButton>
      </ToggleButtonGroup>
      <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: "block" }}>
        {mode === "ai"
          ? "AI generates narrative text from your metrics using GPT-4o-mini. Falls back to Standard on failure."
          : "Uses templated text with metrics from the database. Fast and reliable."}
      </Typography>
    </Box>
  );
}
